<template>
    <BaseDialog
        :showDialog="showDialog"
        headline="lang_PUBLISHING_CONTRACTS_ACTION_GROUP"
        :close="closeDialog"
        persistent
        maxDialogWidth="500"
        :alvqa="alvqa"
    >
        <template v-slot:dialogText>
            <v-container fluid>
                <v-row>
                    <v-col cols="12">
                        <v-text-field
                            v-model="groupName"
                            :label="$t('lang_PUBLISHING_CONTRACTS_CAPTION_GROUP_NAME')"
                            :alvqa="alvqa + '-textfield-group-name'"
                            autofocus
                        ></v-text-field>
                    </v-col>
                </v-row>
            </v-container>
        </template>
        <template v-slot:dialogActions>
            <v-container fluid>
                <v-row>
                    <v-col cols="12" class="text-right">
                        <BaseButton 
                            label="lang_GENERAL_BUTTON_SAVE"
                            @click="confirmGroup"
                            :alvqa="alvqa + '-button-save'"
                        />
                    </v-col>
                </v-row>
            </v-container>
        </template>
    </BaseDialog>
</template>

<script>
import BaseDialog from '@/components/_base/BaseDialog'
import BaseButton from '@/components/_buttons/BaseButton'

export default {
    name: "PublishingContractsGroupDialog",
    components: {
        BaseDialog,
        BaseButton,
    },
    data() {
        return {
            alvqa: 'contracts-publishing-list-dialog-group',
        }
    },
    computed: {
        showDialog: {
            get()     { return this.$store.getters.getShowPublishingContractsGroupDialog },
            set(show) { this.$store.commit('setShowPublishingContractsGroupDialog', show) }
        },
        groupName: {
            get()      { return this.$store.getters.getPublishingContractsGroupDialogName },
            set(value) { this.$store.commit('setPublishingContractsGroupDialogName', value) }
        },
    },
    methods: {
        closeDialog() {
            this.showDialog = false
            this.groupName = ''
        },
        confirmGroup() {
            this.$store.dispatch('groupPublishingContracts')
            this.closeDialog()
        },
    },
}
</script>
